import {RouteConfig} from "vue-router";
import Login from "@/views/Login.vue";
import Dashboard from "@/views/PageDashboard/Dashboard.vue";
import PageForgotPassword from "@/views/PageForgotPassword/PageForgotPassword.vue";
import PageForgotPasswordConfirmCode from "@/views/PageForgotPasswordConfirmCode/PageForgotPasswordConfirmCode.vue";
import PageForgotPasswordSet from "@/views/PageForgotPasswordSet/PageForgotPasswordSet.vue";
import config from "@/config";

export const routes: RouteConfig[] = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      public: true,
    },
  },
  {
    path: "/login/forgot",
    name: "loginForgot",
    component: PageForgotPassword,
    meta: {
      public: true,
    },
  },
  {
    path: "/login/forgot/:email",
    name: "loginForgotEmail",
    component: PageForgotPasswordConfirmCode,
    props: true,
    meta: {
      public: true,
    },
  },
  {
    path: "/login/forgot/:email/:token",
    name: "loginForgotSet",
    component: PageForgotPasswordSet,
    props: true,
    meta: {
      public: true,
    },
  },
  {
    path: "/logout",
    name: "logout",
  },
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "@/views/About.vue"),
  },
  {
    path: "/users",
    name: "users",
    component: () => import(/* webpackChunkName: "users" */ "@/views/PageUserList/PageUserList.vue"),
  },
  {
    path: "/profile/:userId",
    name: "profile",
    component: () => import(/* webpackChunkName: "users" */ "@/views/PageProfile/index.vue"),
  },
  // {
  //   path: "/profile/:userId/subscribers",
  //   name: "profile/subscribers",
  //   props: {
  //     loadSubscribers: true,
  //   },
  //   component: () => import(/* webpackChunkName: "users" */ "@/views/PageRecurring"),
  // },
  {
    path: "/profile/:userId/subscriptions",
    name: "profile/subscriptions",
    component: () => import(/* webpackChunkName: "users" */ "@/views/PageRecurring"),
  },

  {
    path: "/profile/:userId/login",
    name: "profile/login",
    component: () => import(/* webpackChunkName: "users" */ "@/views/PageLoginToken/PageLoginToken.vue"),
    props: true,
  },
  {
    path: "/transactions",
    name: "transactions",
    component: () => import(/* webpackChunkName: "reports" */ "@/views/PageTransactions"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import(/* webpackChunkName: "settings" */ "@/views/PageSettings/index.vue"),
    children: [
      {
        path: "pricing",
        name: "settings/pricing",
        component: () => import(/* webpackChunkName: "settings" */ "@/views/PagePricing"),
      },
      {
        path: "currencies",
        name: "settings/currencies",
        component: () => import(/* webpackChunkName: "settings" */ "@/views/PageSettingsCurrencies"),
      },
      {
        path: "payments",
        name: "setting/paymentSystems",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "settings" */
              "@/views/PageSettingsPaymentSystems/PageSettingsPaymentSystems.vue"
            ),
        },
      },
      {
        path: "tags",
        name: "settings/tags",
        component: () =>
          import(/* webpackChunkName: "settings" */ "@/views/PageSettingsTags/PageSettingsTags.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];
